// Mock data for trademark services website

export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration',
    shortDesc: 'Protect your brand identity with comprehensive trademark registration services.',
    icon: 'Shield',
    link: '/services/trademark-registration'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    shortDesc: 'Secure your creative works with professional copyright registration.',
    icon: 'FileText',
    link: '/services/copyright-registration'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    shortDesc: 'Establish your business entity with expert guidance and support.',
    icon: 'Building2',
    link: '/services/company-formation'
  },
  {
    id: 'trademark-search',
    title: 'Trademark Search',
    shortDesc: 'Comprehensive trademark searches to ensure your brand is available.',
    icon: 'Search',
    link: '/services/trademark-search'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    shortDesc: 'Register your brand on Amazon and protect against counterfeiters.',
    icon: 'ShoppingCart',
    link: '/services/amazon-brand-registry'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Alexandra Mitchell',
    company: 'TechStart Inc.',
    role: 'CEO',
    content: 'The trademark registration process was seamless and professional. They guided us through every step and ensured our brand was fully protected.',
    rating: 5
  },
  {
    id: 2,
    name: 'Marcus Thompson',
    company: 'Creative Studios',
    role: 'Founder',
    content: 'Exceptional service! They helped us register our trademark and copyright in record time. Highly recommended for any business owner.',
    rating: 5
  },
  {
    id: 3,
    name: 'Sophia Patel',
    company: 'Fashion Forward',
    role: 'Brand Director',
    content: 'Professional, knowledgeable, and responsive. They made the complex trademark process simple and stress-free.',
    rating: 5
  },
  {
    id: 4,
    name: 'David Harrison',
    company: 'Wellness Co.',
    role: 'Owner',
    content: 'Outstanding experience from start to finish. Their expertise in trademark law gave us confidence in protecting our brand.',
    rating: 5
  },
  {
    id: 5,
    name: 'Jennifer Lee',
    company: 'Digital Innovations',
    role: 'Managing Director',
    content: 'Fast, efficient, and thorough. They made trademark registration easy and kept us informed throughout the entire process.',
    rating: 5
  },
  {
    id: 6,
    name: 'Robert Martinez',
    company: 'Global Brands LLC',
    role: 'VP of Operations',
    content: 'Highly professional team with deep knowledge of trademark law. They protected our intellectual property perfectly.',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: 'How long does trademark registration take?',
    answer: 'The trademark registration process typically takes 8-12 months from filing to approval, depending on the complexity of the application and any office actions that may arise.'
  },
  {
    id: 2,
    question: 'What is the difference between a trademark and a copyright?',
    answer: 'A trademark protects brand names, logos, and slogans that identify goods or services, while a copyright protects original works of authorship like books, music, art, and software.'
  },
  {
    id: 3,
    question: 'Do I need to conduct a trademark search before filing?',
    answer: 'Yes, conducting a comprehensive trademark search is highly recommended to ensure your desired trademark is available and does not conflict with existing registered marks.'
  },
  {
    id: 4,
    question: 'What classes should I register my trademark under?',
    answer: 'The classes depend on the goods or services your trademark will represent. We help identify the appropriate classes based on your business activities to ensure comprehensive protection.'
  },
  {
    id: 5,
    question: 'Can I trademark a business name?',
    answer: 'Yes, you can trademark your business name if it is used in commerce to identify your goods or services. The name must be distinctive and not merely descriptive.'
  },
  {
    id: 6,
    question: 'What happens if my trademark application is rejected?',
    answer: 'If your application receives an office action or rejection, we work with you to respond appropriately, address examiner concerns, and increase the chances of approval.'
  }
];

// Trademark Process Steps (for Home, Landing Page, Trademark Registration)
export const processSteps = [
  {
    step: 1,
    title: 'Share Your Trademark Information',
    description: 'Provide us with your trademark details, including your brand name, logo, and business information. Our simple form makes it easy to get started in minutes.'
  },
  {
    step: 2,
    title: 'Select Your Package and Pay',
    description: 'Choose the service package that best fits your needs and complete the secure payment process. We offer flexible plans from basic filing to comprehensive protection.'
  },
  {
    step: 3,
    title: 'Expert Review and USPTO Filing',
    description: 'Our experienced trademark attorneys conduct a thorough evaluation of your application, perform a comprehensive search, and file your trademark with the USPTO within 24 hours.'
  }
];

// Copyright Process Steps
export const copyrightProcessSteps = [
  {
    step: 1,
    title: 'Submit Your Creative Work',
    description: 'Provide details about your original work including type (literary, artistic, musical, etc.), author information, and upload your work samples through our secure platform.'
  },
  {
    step: 2,
    title: 'Choose Your Filing Option',
    description: 'Select between standard or expedited processing based on your needs. Complete payment and our team begins preparing your copyright application immediately.'
  },
  {
    step: 3,
    title: 'Professional Filing & Certificate',
    description: 'Our copyright specialists prepare and file your application with the U.S. Copyright Office. You receive your official copyright registration certificate once approved.'
  }
];

// Company Formation Process Steps
export const companyFormationProcessSteps = [
  {
    step: 1,
    title: 'Define Your Business Structure',
    description: 'Provide your company name, business type (LLC, Corporation, etc.), and key details about your business. Our experts help you choose the right structure for your needs.'
  },
  {
    step: 2,
    title: 'Complete Documentation & Payment',
    description: 'Review and approve your formation documents prepared by our team. Select your package and complete the secure payment to proceed with state filing.'
  },
  {
    step: 3,
    title: 'State Filing & Business Setup',
    description: 'We file all necessary documents with your state, obtain your EIN from the IRS, and provide you with a complete business formation package including certificates and operating documents.'
  }
];

// Trademark Search Process Steps
export const trademarkSearchProcessSteps = [
  {
    step: 1,
    title: 'Provide Search Details',
    description: 'Share your proposed trademark name or logo, industry, and intended use. The more information you provide, the more comprehensive your search results will be.'
  },
  {
    step: 2,
    title: 'Comprehensive Database Search',
    description: 'Our experts search federal USPTO databases, state registrations, common law uses, and domain names to identify potential conflicts with your trademark.'
  },
  {
    step: 3,
    title: 'Detailed Report & Consultation',
    description: 'Receive a comprehensive search report highlighting any conflicts, availability analysis, and expert recommendations on how to proceed with your trademark application.'
  }
];

// Amazon Brand Registry Process Steps
export const amazonBrandRegistryProcessSteps = [
  {
    step: 1,
    title: 'Verify Trademark Eligibility',
    description: 'Confirm your trademark is registered or pending with USPTO. Provide your trademark registration number and brand details for Amazon Brand Registry enrollment.'
  },
  {
    step: 2,
    title: 'Prepare Enrollment Application',
    description: 'We compile all required documentation including trademark certificate, brand logo, product images, and company information needed for Amazon enrollment.'
  },
  {
    step: 3,
    title: 'Submit & Activate Brand Protection',
    description: 'Our team submits your application to Amazon Brand Registry, handles any verification requests, and activates your brand protection tools including A+ Content and brand analytics.'
  }
];

export const benefits = [
  {
    title: 'Expert Guidance',
    description: 'Our experienced attorneys provide expert guidance throughout the entire trademark registration process.',
    icon: 'Award'
  },
  {
    title: 'Fast Processing',
    description: 'We ensure your application is filed quickly and accurately to expedite the registration process.',
    icon: 'Zap'
  },
  {
    title: 'Comprehensive Protection',
    description: 'We help you identify all necessary classes and jurisdictions for complete brand protection.',
    icon: 'Shield'
  },
  {
    title: 'Affordable Pricing',
    description: 'Transparent, competitive pricing with no hidden fees or surprise costs.',
    icon: 'DollarSign'
  },
  {
    title: '24/7 Support',
    description: 'Our team is available around the clock to answer your questions and provide updates.',
    icon: 'MessageCircle'
  },
  {
    title: 'Success Guarantee',
    description: 'We stand behind our work with a satisfaction guarantee and commitment to your success.',
    icon: 'CheckCircle2'
  }
];

export const teamMembers = [
  {
    id: 1,
    name: 'David Mitchell',
    role: 'Founding Attorney',
    bio: 'Over 15 years of experience in trademark and intellectual property law.',
    expertise: ['Trademark Law', 'IP Strategy', 'Brand Protection']
  },
  {
    id: 2,
    name: 'Jessica Adams',
    role: 'Senior Trademark Attorney',
    bio: 'Specializes in complex trademark disputes and international registrations.',
    expertise: ['International Trademarks', 'Litigation', 'Portfolio Management']
  },
  {
    id: 3,
    name: 'Robert Park',
    role: 'Copyright Specialist',
    bio: 'Expert in copyright registration and protection for creative works.',
    expertise: ['Copyright Law', 'Creative Industries', 'Digital Rights']
  }
];
